module.exports = __webpack_public_path__ + "img/Login-Img.4e250ae5.jpg";